<template>
  <div class="col-md-4 !tw-mx-auto login-wrapper restore__pass-main">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>

    <form
      :class="{loading: loading, error: error}"
      @submit.prevent
    >
      <Card class="card-login pt-20">
        <section class="inputs">
          <h3 class="mb-6">
            {{ $t('forms.restorePassword') }}
          </h3>
          <div class="row mb-18">
            <div class="col-md-9 col-12">
              {{ $t('forms.restoreText') }}
            </div>
          </div>
          <UiInput
            v-model="model.email"
            v-model:error="errors_.email"
            :label="$t('forms.emailLabel')"
            :placeholder="$t('forms.emailPlaceholder')"
            class="mb-16"
            autofocus
            wrapper-type="registration"
            error-clear-on-change
            @input="checkValid"
          />
          <div class="btn-box !tw-flex !tw-justify-between">
            <RouterLink
              :to="{ path: '/login'}"
              class="btn btn-outline-primary btn-md"
              replace
            >
              &lt; {{ $t('forms.btn.back') }}
            </RouterLink>
            <button
              :disabled="!valid_email || loading"
              class="btn btn-primary btn-md"
              @click="requestRestore"
            >
              {{ $t('forms.btn.submit') }} >
            </button>
          </div>
        </section>
      </Card>
      <div class="loading__block">
        <i class="fa fa-spinner fa-3x fa-fw login__spinner" />
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';


export default {
  data() {
    return {
      emailValidation: false,
      passwordValidation: false,
      loading: false,
      valid_email: false,
      errors_: {},
      model: {
        email: '',
      },
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      model: {
        email: { required, email },
      },
    };
  },
  computed: {

    error() {
      return this.$store.state.errors.request >= 400;
    },
    logo() {
      return this.$config.layout.logoFull;
    },
  },
  methods: {
    async checkValid() {
      this.valid_email = await this.v$.$validate();
    },
    requestRestore() {
      const that = this;
      this.loading = true;
      this.$request
        .post('auth/forgot-password', {
          email: that.model.email,
          return_url: `${window.location.origin}/#/reset-password/%%TOKEN%%/%%AFFILIATE_EMAIL%%`,
        })
        .then(() => {
          this.$router.push('/restore-success');
        })
        .catch((err) => {
          this.errors_ = err.response.data.errors;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import 'styles/restorepassword';
</style>
